import React from 'react';
import { Link } from 'react-router-dom';
import { IMAGES, STATS, FAVOURITES, BRAND } from '../lib/content';
import { Instagram } from 'lucide-react';

const INSTAGRAM_GRID = [
  // 3x2: scene, selfie, scene / scene, selfie, scene
  {
    src: 'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/rjpwpvku_826E8D4D-B16A-42F0-9D11-86EC5C835423.jpeg',
    alt: 'Scallops, tartare and champagne at a candlelit degustation',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/vf5usmb9_IMG_2484.png',
    alt: 'Candlelit fireplace, velvet cushions and a glass of red wine',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/usg387by_IMG_4354.jpeg',
    alt: 'Waterfall through mossy temperate rainforest',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/y4xbpz2c_IMG_3859.jpeg',
    alt: 'Cedar hot tub overlooking a New Zealand valley at dusk',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/nxoe9cov_IMG_1594.jpeg',
    alt: 'Mirror selfie in a little black dress with a champagne flute',
  },
  {
    src: 'https://customer-assets.emergentagent.com/job_booking-hub-427/artifacts/bh7bscwu_IMG_4446.jpeg',
    alt: 'Lobster crudo and a coral-pink cocktail on a marble bar',
  },
];

export default function About() {
  return (
    <div>
      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-8">
        <div className="font-label text-zb-accent mb-6">About</div>
        <h1 className="font-serif text-5xl md:text-7xl text-zb-ink tracking-tight leading-[0.95]">
          A little <span className="italic text-zb-brand">about me.</span>
        </h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5 zb-fade-up">
          <div className="zb-img-wrap aspect-[3/4]">
            <img src={IMAGES.about} alt="Zahra Belle" />
          </div>
        </div>

        <div className="md:col-span-7 md:pt-8 zb-fade-up zb-delay-1">
          <p className="font-serif text-2xl md:text-3xl text-zb-ink leading-snug italic">
            Playful, passionate, and genuinely down to earth.
          </p>

          <div className="mt-10 space-y-6 md:space-y-7 text-zb-ink2 text-base md:text-[16px] leading-[1.85]">
            <p className="font-serif italic text-zb-ink text-xl md:text-2xl leading-snug">
              The spark you&rsquo;ve been missing..
            </p>

            <p>
              Hi you,
            </p>

            <p>
              Are you craving the kind of chemistry where your mind goes
              quiet, your body wakes up, and the present moment burns with
              desire?
            </p>

            <p>
              I&rsquo;m Zahra. Playful, passionate, and genuinely down to
              earth.. here to give you exactly what&rsquo;s been missing.
            </p>

            <p>
              I&rsquo;m the girl next-door with undeniable charm and sex
              appeal who you&rsquo;ve imagined and finally get to take home.
            </p>

            <p>
              From the moment we meet, you&rsquo;ll notice my cheeky,
              seductive smile, the way my natural beauty radiates from within,
              and the ease between us that quickly gets your blood flowing.
            </p>

            <p>
              I offer a deeply sensual, authentic girlfriend experience for
              the man who wants more than surface-level.
            </p>

            <p>
              Slow, hungry kisses, teasing tension, laughter and deep
              conversation that leaves you simultaneously satisfied and
              wanting more.
            </p>

            <p>
              Our time together is unrushed and unscripted, a complete escape
              from the pressure of the outside world.
            </p>

            <p>
              What makes time with me different is how real it feels.
            </p>

            <p>
              Nothing forced, performative, or transactional.
            </p>

            <p>
              Just real chemistry and connection. Intimacy that builds each
              time we meet.
            </p>

            <p>
              Choose how you want to experience me:
            </p>

            <p>
              <span className="font-serif text-zb-ink">GFE</span> &mdash; your
              sweet, sensual girlfriend. Effortless, warm, and completely
              yours in the moment.
            </p>

            <p>
              <span className="font-serif text-zb-ink">Naughty GFE</span>{' '}
              &mdash; your cheeky girlfriend. Playful, teasing, and undeniably
              hot for you in all the right ways.
            </p>

            <p>
              <span className="font-serif text-zb-ink">VIP GFE</span> &mdash;
              my clients&rsquo; favourite for a reason. Unrestricted and
              indulgent, where we let go and follow the chemistry. A
              beautifully curated, luxury date where I spoil you and we
              create something truly unforgettable together.
            </p>

            <p>
              My clients tell me how easy I am to talk to, how comfortable
              they feel, and how naturally it all unfolds.
            </p>

            <p>
              They love that what they see is what they get. My natural,
              unedited body, with the kind of curves they can&rsquo;t stop
              thinking about.
            </p>

            <p>
              Many choose longer dates because once you feel it, rushing
              simply isn&rsquo;t an option.
            </p>

            <p>
              If you&rsquo;ve been missing that sense of aliveness, real
              intimacy, effortless connection, you&rsquo;ll find it here.
            </p>

            <p>
              I have a full, well-rounded life, so availability is limited.
            </p>

            <p>
              If you feel that pull, trust it.
            </p>

            <p>
              Send me a text or email to secure your time before it&rsquo;s
              gone.
            </p>

            <p className="italic font-serif text-zb-ink text-xl md:text-2xl leading-snug pt-2">
              Don&rsquo;t keep me waiting.
            </p>
            <p className="italic font-serif text-zb-brand text-xl md:text-2xl leading-snug -mt-4">
              Z xx
            </p>
          </div>

          <Link
            to="/contact"
            data-testid="about-cta-book"
            className="inline-block mt-12 rounded-full bg-zb-brand hover:bg-zb-brandHover text-zb-bg px-8 py-3.5 text-xs tracking-[0.22em] uppercase transition-colors"
          >
            Request an introduction
          </Link>
        </div>
      </section>

      {/* STATS */}
      <section className="bg-zb-bg2 border-y border-zb-border">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-8">
            {STATS.map(([label, value]) => (
              <div key={label} data-testid={`about-stat-${label.toLowerCase()}`}>
                <div className="font-label text-zb-accent mb-3">{label}</div>
                <div className="font-serif text-2xl md:text-3xl text-zb-ink">{value}</div>
              </div>
            ))}
          </div>
          <div className="mt-12 md:mt-14 pt-10 md:pt-12 border-t border-zb-border">
            <div className="font-label text-zb-accent mb-6">A few favourite things</div>
            <div className="flex flex-wrap gap-3 md:gap-4" data-testid="about-favourites">
              {FAVOURITES.map((f) => (
                <span
                  key={f}
                  className="inline-block font-serif text-zb-ink text-lg md:text-2xl px-5 md:px-7 py-3 md:py-4 rounded-full border border-zb-border bg-zb-bg"
                >
                  {f}
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* WHAT I VALUE — moody burgundy band */}
      <section
        data-testid="about-values-band"
        className="bg-zb-brand text-zb-bg"
      >
        <div className="max-w-5xl mx-auto px-6 md:px-12 py-16 md:py-24 text-center">
          <div className="font-label text-zb-bg/75 mb-6 tracking-[0.32em]">
            Deeper than surface level
          </div>
          <h3 className="font-serif text-3xl md:text-5xl leading-tight mb-10 md:mb-14">
            What I truly <span className="italic">value.</span>
          </h3>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-14 gap-y-4 md:gap-y-5 text-left max-w-3xl mx-auto">
            {[
              'Humour',
              'The luxury of time',
              'Sensuality in all its forms',
              'Stimulating conversation',
              'Adventurous souls',
              'Authenticity',
            ].map((v, i) => (
              <li
                key={v}
                className="font-serif italic text-2xl md:text-3xl border-b border-zb-bg/25 pb-3"
              >
                <span className="not-italic font-label text-zb-bg/60 text-[10.5px] tracking-[0.28em] mr-4 align-middle">
                  0{i + 1}
                </span>
                {v}
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* FOLLOW ALONG — Instagram widget home */}
      <section className="bg-zb-bg2 border-t border-zb-border">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 md:py-18">
          <div className="text-center mb-10 md:mb-12">
            <div className="font-label text-zb-accent mb-4">On Instagram</div>
            <h3 className="font-serif text-3xl md:text-5xl text-zb-ink leading-tight">
              Follow <span className="italic text-zb-brand">along.</span>
            </h3>
            <p className="mt-5 text-zb-ink2 text-base max-w-xl mx-auto leading-relaxed">
              Find me on Instagram for little glimpses of my days. But
              remember, in-person is where the real magic lives.
            </p>
          </div>

          {/* Instagram-style 3x2 grid */}
          <div
            data-testid="instagram-grid"
            className="max-w-4xl mx-auto grid grid-cols-3 gap-2 md:gap-3"
          >
            {INSTAGRAM_GRID.map((item, i) => (
              <a
                key={i}
                href={BRAND.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid={`instagram-tile-${i}`}
                className="zb-img-wrap aspect-square group relative zb-fade-up overflow-hidden"
                style={{ animationDelay: `${i * 0.06}s` }}
              >
                <img
                  src={item.src}
                  alt={item.alt}
                  loading="lazy"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: item.objectPosition || 'center',
                    transform: item.zoom ? `scale(${item.zoom}) translateY(${item.panY || 0}%)` : undefined,
                    transformOrigin: 'center center',
                  }}
                />
                <div className="absolute inset-0 bg-zb-ink/0 group-hover:bg-zb-ink/25 transition-colors duration-500 flex items-center justify-center pointer-events-none">
                  <Instagram
                    size={22}
                    className="text-zb-bg opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                  />
                </div>
              </a>
            ))}
          </div>

          <div className="mt-10 text-center">
            <a
              href={BRAND.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid="about-instagram-cta"
              className="inline-flex items-center gap-2 rounded-full bg-zb-ink hover:bg-zb-brand text-zb-bg px-8 py-3.5 text-xs tracking-[0.22em] uppercase transition-colors"
            >
              <Instagram size={14} /> Follow {BRAND.instagramHandle}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
